import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Box, Button, Chip, Divider, Stack, Typography } from "@mui/material";

import { Images } from "../../assets/common";
import CloseIcon from "@mui/icons-material/Close";
import OutsideClickHandler from "react-outside-click-handler";
import Loader from "../Loader";
import ApiService from "../../services/api-service";
import { fullName, getErrorString } from "../../constants/function";
import BidPopup from "../BidPopup";
import notifier from "../Notifier";
import SuccessPopup from "../SuccessPopup";

import "./index.scss";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";
import { SocketContext } from "../../context/socket";
import { useTranslation } from "react-i18next";
export default function BiddingPopup(props) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const socket = useContext(SocketContext).Socket;
  const history = useHistory();
  const [message, setMessage] = useState(null);
  const [openBid, setOpenBid] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [show, setShow] = React.useState();
  const [currency, setCurrency] = React.useState("siki");
  const handleClick = (coin) => {
    setCurrency(coin);
    setShow(false);
  };
  const [amount, setAmount] = React.useState("");

  /**
   * @param  {} nftId
   * getting auction data by nft id
   */
  const getAuctionData = async (nftId) => {
    try {
      setMessage(t("loader.message7"));
      setLoading(true);
      const response = await ApiService.AUCTION_LIST(nftId);
      setData([...response["result"]]);
      var objDiv = document.getElementById("__bidding_data");
      objDiv.style.scrollBehavior = "smooth";
      objDiv.scrollTop = objDiv.scrollHeight;
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  /**
   * @param  {} nftId
   * getting loggeding user bids
   */
  const getBidData = async (nftId) => {
    try {
      setMessage(t("loader.message25"));
      setLoading(true);
      const response = await ApiService.AUCTION_LIST(nftId);
      setData([...response["result"]]);
      var objDiv = document.getElementById("__bidding_data");
      objDiv.style.scrollBehavior = "smooth";
      objDiv.scrollTop = objDiv.scrollHeight;
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  React.useEffect(() => {
    if (props["isAuction"] === true) getAuctionData(props["nft"]["nftId"]);
    if (props["isAuction"] === false) getBidData(props["nft"]["nftId"]);

    return () => {
      setData([]);
      setLoading(true);
    };
  }, []);
  const handleBid = (bidAmount) => {
    if (bidAmount) {
      setShowSuccess(true);
    } else setOpenBid(false);
  };
  const bid = async (auctionId) => {
    if (amount < props["highestBid"]) {
      notifier.info("Bid amount cannot be less than highest bid");
    } else {
      try {
        setMessage(t("loader.message26"));
        const payload = {
          auctionId: auctionId,
          amount: amount,
          currency: currency,
          type: "music",
        };
        setLoading(true);
        const response = await ApiService.BID_NFT_V2(payload);
        setLoading(false);
        setShowSuccess(false);
        setMessage(null);
        notifier.success(response["result"]);
        dispatch(getBalance());
        if (data.length > 0) {
          const bidData = {
            auctionId: auctionId,
            bidDifference: props?.nft?.highestBid,
            amount: amount,
            userDetail: data[0].userDetail,
          };
          socket.emit("bidding", bidData);
        }

        props.handleClose(false);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    }
  };
  React.useEffect(() => {
    socket.on("realTimeBidding", function (realtimeBid) {
      if (
        props["isAuction"] === true &&
        props?.nft?.nftDetails?.auctionId === realtimeBid["auctionId"]
      ) {
        const d = data;
        data.push(realtimeBid);
        setData([...data]);
        var objDiv = document.getElementById("__bidding_data");
        setTimeout(() => {
          if (objDiv) {
            let newElement = document.getElementById(
              `${data.length - 1}--${realtimeBid.auctionId}`
            );
            objDiv.style.scrollBehavior = "smooth";
            newElement.style.animationDuration = ".2s";
            newElement.style.animationName = "slidein";

            objDiv.scrollTop = objDiv.scrollTop + newElement.scrollHeight;
          }
        }, 0);
      }
    });
  }, [socket, data]);
  return (
    <Box className="_bidding">
      <Stack spacing={1} direction="row" className="_bidding_header">
        <img
          className="avatar"
          src={
            props?.nft?.nftDetails?.owner?.profileImg?.filePath ||
            Images.default_user
          }
          alt="owner"
        />
        <Stack direction="column">
          <Typography className="fs-16 text-white">
            {props?.nft?.details?.title}
          </Typography>
          <Typography
            className="fs-14 text-white _cp"
            onClick={() => {
              history.push(
                `/app/ArtistProfile/${props?.nft?.nftDetails?.owner?._id}`
              );
              props.handleClose(false);
            }}
          >
            {fullName(props?.nft?.nftDetails?.owner)}
          </Typography>
        </Stack>
        <CloseIcon
          className="_cp ml_auto"
          color="default"
          onClick={() => props.handleClose()}
        />
      </Stack>
      <Divider orientation="horizontal" />
      {props["isAuction"] ? (
        <Box className="_auction_price_container">
          <Stack
            className="_auctioned_price"
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Typography className="fs-16 _auction_text">
              {t("biddingPopup.text1")}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={1}>
              <img
                style={{ width: "16px" }}
                src={
                  props?.nft?.currency === "siki"
                    ? Images.siki_coin
                    : Images.hbar_1
                }
                alt=""
              />
              <Typography className="fs-16 fw-b">
                {data.length > 0
                  ? data[data.length - 1]?.amount
                  : props?.nft?.highestBid.toFixed(2)}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      ) : null}
      <Stack
        id="__bidding_data"
        className={
          "_bidding_body" + (props["isAuction"] ? " _auction_body" : "")
        }
        sx={{ maxHeight: props["isAuction"] ? "50%" : "35%" }}
        spacing={1}
      >
        {data &&
          data.map((bidInfo, index) => (
            <Stack
              id={`${index}--${bidInfo.auctionId}`}
              key={index}
              spacing={1}
              direction="row"
              className={
                index === 3 && !props["isAuction"] ? "_bidding_body_self" : ""
              }
            >
              <img
                className="avatar-sm"
                src={bidInfo?.userDetail?.profileImg?.filePath}
                alt="Bidding"
              />
              <Stack direction="column" className="_bidding_body_self_info">
                <Typography className="fs-14 text-white">
                  {fullName(bidInfo?.userDetail)}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Typography className="fs-16 success">
                    +{(bidInfo?.bidDifference).toFixed(2)}
                  </Typography>
                  <Box sx={{ padding: "6px 0" }}>
                    <Divider
                      sx={{ borderColor: "#999999" }}
                      orientation="vertical"
                    />
                  </Box>
                  <Typography className="fs-16 faded">
                    {bidInfo?.amount}
                  </Typography>
                  <Box sx={{ padding: "6px 0" }}>
                    <Divider
                      sx={{ borderColor: "#999999" }}
                      orientation="vertical"
                    />
                  </Box>
                  <Typography className="fs-16 canceled">
                    Rank: {bidInfo?.rank}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          ))}
      </Stack>
      {props["isAuction"] ? null : (
        <>
          <Stack className="_bidding_input">
            <input
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              className="_bidding_input_box"
              type="number"
              placeholder={t("biddingPopup.text2")}
            />
            <Box className="_bidding_dropdown">
              <Stack
                className={"_bidding_coin" + (show ? " __show_coin" : "")}
                direction="row"
                spacing={1}
                onClick={() => setShow(!show)}
              >
                <Typography sx={{ paddingLeft: "20px", color: "#D5D5D5" }}>
                  {currency}
                </Typography>
                <img
                  src={Images.arrowdown}
                  sx={{ width: "30px" }}
                  className="__transform"
                  alt=""
                />
              </Stack>
              {show ? (
                <OutsideClickHandler onOutsideClick={() => setShow(false)}>
                  <Stack className="_bidding_menu">
                    <Typography onClick={() => handleClick("siki")}>
                      siki
                    </Typography>
                    {/* <Typography onClick={() => handleClick("hbar")}>
                      hbar
                    </Typography> */}
                  </Stack>
                </OutsideClickHandler>
              ) : null}
            </Box>
          </Stack>
          <Stack className="_bidding_fast">
            <Box className="_bidding_fast_input">
              <Typography sx={{ width: "max-content" }} className="fade-text">
                {t("biddingPopup.text10")} /
                <span className="text-white">{t("biddingPopup.text11")}</span>
              </Typography>
              {[
                { amount: "+50", value: 50 },
                { amount: "+100", value: 100 },
                { amount: "+250", value: 250 },
                { amount: "+500", value: 500 },
                { amount: "+1000", value: 1000 },
                { amount: "+2000", value: 2000 },
              ].map((fast, index) => (
                <Chip
                  className="_cp"
                  key={index}
                  sx={{ width: "max-content" }}
                  label={fast["amount"]}
                  variant="outlined"
                  onClick={() =>
                    setAmount(
                      fast["value"] + data[data.length - 1]["highestBid"]
                    )
                  }
                />
              ))}
            </Box>
          </Stack>

          <Box className="_bidding_button">
            <Button
              disabled={!amount}
              sx={{ width: "100%", fontSize: "17px" }}
              variant="contained"
              color="primary"
              onClick={() => bid(data[0]["auctionId"])}
            >
              {t("biddingPopup.button1")}
            </Button>
          </Box>
        </>
      )}
      {showSuccess ? (
        <SuccessPopup
          open={showSuccess}
          handleClose={() => setShowSuccess(false)}
          message={t("success.message1")}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={message ? message : t("loader.message8")}
        />
      ) : null}
    </Box>
  );
}
